import { useTracking } from 'shared/providers/TrackingProvider';
import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { GeneralEvents } from 'shared/providers/TrackingProvider/EventNames';

interface ErrorBoundaryProps {
  error: string;
}

const ErrorBoundaryFallback = ({ error }: ErrorBoundaryProps): JSX.Element => {
  const { trackEvent } = useTracking();

  useEffect(() => {
    trackEvent(GeneralEvents.ErrorBoundaryFallbackTriggered, {
      errorMessage: error,
    });
  }, [error, trackEvent]);

  return (
    <ErrorMessageContainer>
      <ErrorHeadline>An internal server error has occurred.</ErrorHeadline>
      <ErrorMessage>
        An error has occurred while processing your request. The Otto support team has been notified of the problem. If
        you believe you have additional information that may be of help in reproducing or correcting the error, please
        contact Otto Support.
      </ErrorMessage>
    </ErrorMessageContainer>
  );
};

export default ErrorBoundaryFallback;

const ErrorMessageContainer = styled.div`
  margin: 0 auto;
  position: relative;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  width: 60%;
`;

const ErrorHeadline = styled.h1`
  color: hsl(0, 0%, 70%);
  display: inline-block;
  font-size: 3rem;
  margin-bottom: 0.1em;
`;

const ErrorMessage = styled.p`
  color: hsl(0, 0%, 70%);
  display: inline-block;
  font-size: 1rem;
  text-align: left;
  width: 95%;
`;
